<template>
  <ul class="sidebar navbar-nav">
    <li class="nav-item" :class="{ active: index == 1}">
      <router-link class="nav-link" to="/cong_viec">
       <i class="fas fa-caret-square-down fa-lg"></i>
        <span>Công việc<br/>được giao</span>
      </router-link>
    </li>
    <li class="nav-item" :class="{ active: index == 2}" v-if="task_create">
      <router-link class="nav-link" to="/cong_viec_da_giao">
        <i class="fas fa-caret-square-up fa-lg"></i>
        <span>Công việc<br/> đã giao</span>
      </router-link>
    </li>
    <li class="nav-item" :class="{ active: index == 3}"  v-if="task_readall">
      <router-link class="nav-link" to="/tat_ca_cong_viec">
        <i class="fas fa-tasks fa-lg"></i>
        <span>Tất cả <br/>công việc</span>
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {
  name: "TaskSideBar",
  props: ["index"],
  computed: {    
    task_readall() {
      return this.$store.getters.hasPermission("task_readall");
    },
    task_create() {
      return this.$store.getters.hasPermission("task_create");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
